import React from 'react';
import {MainTop} from "../../../../../main-top/Main-top";

import {ReactComponent as BackIcon} from '../../../../../../../../../assets/main/groups/main-top/back.svg';
import {HomeWorkContent} from "./home-work-content/HomeWorkContent";
import AuthWrapper from "../../../../../../../../auth-wrapper/AuthWrapper";
import {useAppSelector} from "common/hook";

export const HomeWork = () => {
    const homeworkData = useAppSelector(state => state.homeWorkTeacher?.data);

   const studentId = homeworkData?.student?.id
    const groupId = homeworkData?.lesson?.groupId

    return (
        <AuthWrapper>
            <div className="app-main">
                <MainTop title={'Домашнее задание'}
                         tabs={false}
                         setting={false}
                         edit={false}
                         link={`/groups/${groupId}/students-pages/${studentId}`}
                         icons={<BackIcon/>} onlineTabs={false}/>
                <HomeWorkContent/>
            </div>
        </AuthWrapper>
    );
};

